module.exports = __webpack_public_path__ + "img/3d99ed39-00c5-4546-bd3f-2a75bbf8b01a.3fcf2148.webp";